<script setup lang="ts"></script>

<template>
  <v-icon icon="fat fa-chevron-up" :size="14"></v-icon>
</template>
